import React from 'react';
import PropTypes from 'prop-types';

const ConfirmationModal = ({ showModal, setShowModal, title, message, onConfirm, btntype, btntext }) => {
    if (!showModal) return null;

    return (
        <div className="modal fade show" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden={showModal ? 'false' : "true"} style={{
            display: 'block', background: 'rgba(0, 0, 0, 0.7)'
        }
        } >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className={`modal-header ${btntype === 'success' ? 'success-1' : 'danger-1'}`}>
                        <h1 className="modal-title fs-5" id="staticBackdropLabel">{title}</h1>
                    </div>
                    <div className="modal-body">
                        <p>{message}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal" onClick={() => setShowModal(false)}>Cancel</button>
                        {onConfirm && (
                            <button type="button" className={`btn btn-${btntype || 'danger'}  btn-sm`} onClick={onConfirm}>{btntext || 'Delete'}</button>
                        )}
                    </div>
                </div>
            </div>
        </div >
    );
};

ConfirmationModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onConfirm: PropTypes.func,
    btntype: PropTypes.string,
    btntext: PropTypes.string
};

export default ConfirmationModal;